import template from './job-requests.html';
import controller from './job-requests.controller';
import './job-requests.styl';

let jobRequests = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default jobRequests;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/job-requests/job-requests.component.js
 **/